import { render, staticRenderFns } from "./longSentence.vue?vue&type=template&id=db8a3814&scoped=true&"
import script from "./longSentence.vue?vue&type=script&lang=js&"
export * from "./longSentence.vue?vue&type=script&lang=js&"
import style0 from "./longSentence.vue?vue&type=style&index=0&id=db8a3814&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8a3814",
  null
  
)

export default component.exports